// some params (like bi token) look like GUID but there are not valid GUIDS
const GUID_LIKE_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

const typeValidators = {
  guid: val => val && _.isString(val) && GUID_LIKE_RE.test(val),
  bool: val => _.isBoolean(val),
  numeric: val => _.isNumber(val),
};

const validators = {
  length(val, length) {
    return val && !_.isUndefined(val.length) && val.length === length;
  },
  maxLength(val, maxLength) {
    return val && !_.isUndefined(val.length) && val.length <= maxLength;
  },
  values(val, values) {
    return values && _.includes(values, val);
  },
  type(val, type) {
    if (typeValidators[type]) {
      return typeValidators[type](val);
    }
    return typeof val === type;
  },
};

const parsers = {
  subStr(val, length) {
    if (val && val.substr) {
      return val.substr(0, Math.min(val.length, length));
    }
    return val;
  },
};

export function valid(value, restrictions) {
  for (const key in restrictions) {
    if (validators[key] && !validators[key](value, restrictions[key])) {
      return false;
    }
  }
  return true;
}

export function parse(value, restrictions) {
  if (_.isFunction(value)) {
    value = value();
  }
  for (const key in restrictions) {
    if (restrictions.hasOwnProperty(key)) {
      value = parsers[key] ? parsers[key](value, restrictions[key]) : value;
    }
  }
  return value;
}



// WEBPACK FOOTER //
// ./src/shared/bi/bi-parsers.js